import React from 'react';
import { Redirect } from 'react-router-dom';
import { State as AdminState } from 'src/state/ducks/admin/reducers';
import { UserRole } from 'src/firebase/db/Admins';

interface Props {
  isSignIn: boolean;
  children: any;
}

interface AdminProps {
  user: AdminState['user'];
  children: any;
}

interface ShopProps {
  login_shop_id: string;
  shop_id: string;
  children: any;
}

const AuthHandler = (props: Props) => {
  console.log(props.isSignIn);
  return props.isSignIn ? props.children : <Redirect to={'/login'} />;
};
/**
 *
 * @param param0 user
 */
const AdminHandler = (props: AdminProps) => {
  const isAdmin = props.user.role === UserRole.ADMIN;
  return isAdmin ? (
    props.children
  ) : (
    <Redirect
      to={{
        pathname: '/error',
        state: { errCode: 403 },
      }}
    />
  );
};
/**
 *
 */
const MyShopHandler = (props: ShopProps) => {
  const isMyShop = props.login_shop_id === props.shop_id;

  return isMyShop ? (
    props.children
  ) : (
    <Redirect
      to={{
        pathname: '/error',
        state: { errCode: 403 },
      }}
    />
  );
};
export { AuthHandler, AdminHandler, MyShopHandler };
export default AuthHandler;
